import { GxCheckbox } from '@garpix/garpix-web-components-react';
import React, { FC } from 'react';

interface ICheckbox {
  name: string;
  checked: boolean;
  setValue?: (name: string, target: boolean) => void;
  flag?: boolean;
  props?: any;
  onClick?: any,
  handleChange?: any,
}

const Checkbox: FC<ICheckbox> = ({
  children,
  name,
  setValue,
  handleChange,
  ...props
}) => {

  const handleChecked = ({ target }: any) => {
    if (setValue) {
      setValue(name, target.checked)
    }
  }
  return (
    <GxCheckbox onGx-change={setValue ? handleChecked : handleChange} {...props}>
      {children}
    </GxCheckbox>
  );
};

export default Checkbox;
